module.exports = __webpack_public_path__ + "static/img/10.2a24acc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/zh/10.png
// module id = ryqq
// module chunks = 0